export default __webpack_public_path__ + "static/media/klaviyo.409cb8b7.png";